import { render, staticRenderFns } from "./ActionsFormationCollaborateur.vue?vue&type=template&id=9bb8c668&"
import script from "./ActionsFormationCollaborateur.vue?vue&type=script&lang=js&"
export * from "./ActionsFormationCollaborateur.vue?vue&type=script&lang=js&"
import style0 from "./ActionsFormationCollaborateur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports